<template>
  <v-row>
    <v-col cols="12">
      <v-card outlined class="rounded-card">
        <v-subheader class="pt-1">Links</v-subheader>
        <v-divider/>
        <px-circular-loading v-if="loading"/>
        <px-lista-links v-if="links && links.length"
                        :links="links"
                        :loading="loading"/>
        <v-card-text v-else>
          Nenhum link para esse registro
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import RequisicaoService from '@/modules/requisicao/requisicoes-service';

export default {
  props: {
    requisicao: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      links: [],
    };
  },
  methods: {
    getLinks() {
      this.loading = true;
      RequisicaoService.getLinks(this.requisicao.id)
        .then(({ data }) => {
          this.links = data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  created() {
    this.getLinks();
  },
};
</script>
